import { filterKeyParts, type QueryFilters } from '../core/queryKeyUtils';

export const accountantKeys = {
  all: ['accountant'] as const,
  bundle: {
    summary: (filters?: QueryFilters) =>
      [...accountantKeys.all, 'bundle', 'summary', ...filterKeyParts(filters)] as const,
    income: (filters?: QueryFilters) =>
      [...accountantKeys.all, 'bundle', 'income', ...filterKeyParts(filters)] as const,
    expenses: (filters?: QueryFilters) =>
      [...accountantKeys.all, 'bundle', 'expenses', ...filterKeyParts(filters)] as const,
    reports: (filters?: QueryFilters) =>
      [...accountantKeys.all, 'bundle', 'reports', ...filterKeyParts(filters)] as const,
    cashFlow: (filters?: QueryFilters) =>
      [...accountantKeys.all, 'bundle', 'cash-flow', ...filterKeyParts(filters)] as const,
  },
  income: {
    all: () => [...accountantKeys.all, 'income'] as const,
    filterOptions: () => [...accountantKeys.income.all(), 'filter-options'] as const,
    summary: (filters?: QueryFilters) =>
      [...accountantKeys.income.all(), 'summary', ...filterKeyParts(filters)] as const,
    studentInvoices: (filters?: QueryFilters) =>
      [...accountantKeys.income.all(), 'student-invoices', ...filterKeyParts(filters)] as const,
    placementPayments: (filters?: QueryFilters) =>
      [...accountantKeys.income.all(), 'placement-payments', ...filterKeyParts(filters)] as const,
    additionalIncomes: (filters?: QueryFilters) =>
      [...accountantKeys.income.all(), 'additional-incomes', ...filterKeyParts(filters)] as const,
  },
  expenses: {
    all: () => [...accountantKeys.all, 'expenses'] as const,
    costs: (filters?: QueryFilters) =>
      [...accountantKeys.expenses.all(), 'costs', ...filterKeyParts(filters)] as const,
    salaries: (filters?: QueryFilters) =>
      [...accountantKeys.expenses.all(), 'salaries', ...filterKeyParts(filters)] as const,
    combinedSummary: (filters?: QueryFilters) =>
      [...accountantKeys.expenses.all(), 'combined-summary', ...filterKeyParts(filters)] as const,
    categorySummary: (filters?: QueryFilters) =>
      [...accountantKeys.expenses.all(), 'category-summary', ...filterKeyParts(filters)] as const,
    list: (filters?: QueryFilters) =>
      [...accountantKeys.expenses.all(), 'list', ...filterKeyParts(filters)] as const,
    pending: (filters?: QueryFilters) =>
      [...accountantKeys.expenses.all(), 'pending', ...filterKeyParts(filters)] as const,
  },
  installments: {
    all: () => [...accountantKeys.all, 'installments'] as const,
    summary: () => [...accountantKeys.installments.all(), 'summary'] as const,
    list: (filters?: QueryFilters) =>
      [...accountantKeys.installments.all(), 'list', ...filterKeyParts(filters)] as const,
  },
  customerEstimates: {
    all: () => [...accountantKeys.all, 'customer-estimates'] as const,
    list: (filters?: QueryFilters) =>
      [...accountantKeys.customerEstimates.all(), 'list', ...filterKeyParts(filters)] as const,
  },
  dashboard: {
    all: () => [...accountantKeys.all, 'dashboard'] as const,
    summary: (filters?: QueryFilters) =>
      [...accountantKeys.dashboard.all(), 'summary', ...filterKeyParts(filters)] as const,
  },
  ledger: {
    all: () => [...accountantKeys.all, 'ledger'] as const,
    transactions: (filters?: QueryFilters) =>
      [...accountantKeys.ledger.all(), 'transactions', ...filterKeyParts(filters)] as const,
  },
  salesCollections: {
    all: () => [...accountantKeys.all, 'sales-collections'] as const,
    details: (filters?: QueryFilters) =>
      [...accountantKeys.salesCollections.all(), 'details', ...filterKeyParts(filters)] as const,
  },
  cashFlow: {
    all: () => [...accountantKeys.all, 'cash-flow'] as const,
    position: (filters?: QueryFilters) =>
      [...accountantKeys.cashFlow.all(), 'position', ...filterKeyParts(filters)] as const,
    forecast: (filters?: QueryFilters) =>
      [...accountantKeys.cashFlow.all(), 'forecast', ...filterKeyParts(filters)] as const,
    weekly: (filters?: QueryFilters) =>
      [...accountantKeys.cashFlow.all(), 'weekly', ...filterKeyParts(filters)] as const,
    byMethod: (filters?: QueryFilters) =>
      [...accountantKeys.cashFlow.all(), 'by-method', ...filterKeyParts(filters)] as const,
  },
  refunds: {
    all: () => [...accountantKeys.all, 'refunds'] as const,
    list: (filters?: QueryFilters) =>
      [...accountantKeys.refunds.all(), 'list', ...filterKeyParts(filters)] as const,
  },
  reports: {
    all: () => [...accountantKeys.all, 'reports'] as const,
    profitLoss: (filters?: QueryFilters) =>
      [...accountantKeys.reports.all(), 'profit-loss', ...filterKeyParts(filters)] as const,
    revenueByBranch: (filters?: QueryFilters) =>
      [...accountantKeys.reports.all(), 'revenue-by-branch', ...filterKeyParts(filters)] as const,
    revenueByCourse: (filters?: QueryFilters) =>
      [...accountantKeys.reports.all(), 'revenue-by-course', ...filterKeyParts(filters)] as const,
    monthlyComparison: (filters?: QueryFilters) =>
      [...accountantKeys.reports.all(), 'monthly-comparison', ...filterKeyParts(filters)] as const,
    paymentMethods: (filters?: QueryFilters) =>
      [...accountantKeys.reports.all(), 'payment-methods', ...filterKeyParts(filters)] as const,
  },
  groupRates: {
    all: () => [...accountantKeys.all, 'group-rates'] as const,
    list: (filters?: QueryFilters) =>
      [...accountantKeys.groupRates.all(), 'list', ...filterKeyParts(filters)] as const,
  },
} as const;
